import { Component, OnInit } from '@angular/core';
import { IGroup } from '../../../models/group';
import { Observable } from 'rxjs';
import { GroupsService } from '../../../abstraction/groups.service';
import { coins_group } from '../../../utils/coinsGroup';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-make-trade',
  templateUrl: './make-trade.component.html',
  styleUrls: ['./make-trade.component.scss'],
})
export class MakeTradeComponent implements OnInit {
  srcCoinSelectorOpened = false;
  destCoinSelectorOpened = false;
  coins = coins_group;
  cryptoBalances: { [coin: string]: string } = {};
  group: Observable<IGroup>;
  coinClicked: string;
  constructor(
    private groupsService: GroupsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.groupsService.getGroup();
    this.group = this.groupsService.group;
    this.group.subscribe((resp) => {
      if (resp) {
        Object.entries(resp.balance).map((resp) => {
          this.cryptoBalances[resp[0]] = Math.abs(parseFloat(resp[1])).toString();
        });
      }
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.coin) this.coinClicked = params.coin;
    });
    this.router.navigate([], {
      queryParams: {
        coin: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  closeCoinSelector() {
    this.srcCoinSelectorOpened = false;
    this.destCoinSelectorOpened = false;
  }
}
